import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import Data from "../../content/find.json";
import ActionCreator from "../ActionCreator";
import * as Widget from "./Widget2";
import Image from "./Image";

class FindIntroduction extends Component {
  render() {
    let { find, navActions } = this.props;
    let data = Data.find(d => d.name === find);

    return (
      <Wrapper>
        <div className="graphic">
          <Image background src={`./images/pages/find/${find}.png`} />
        </div>
        <div className="title">{data.display}</div>
        <p className="description">{data.description}</p>
        <Widget.Row>
          {/* <button onClick={() => 0}>了解更多</button> */}
          <Widget.AnimatedButton
            onClick={() => navActions.push(data.viewProductsLink)}
          >
            查看商品
          </Widget.AnimatedButton>
        </Widget.Row>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  & > .graphic {
    margin-bottom: 30px;
    width: 100%;
    height: 258px;
  }

  & > .title {
    margin-bottom: 20px;
    letter-spacing: 3.9px;
    font-size: 26px;
  }

  & > .description {
    margin-bottom: 20px;
    letter-spacing: 1px;
    white-space: pre-wrap;
    line-height: 30px;
    font-size: 14px;
  }

  button {
    cursor: pointer;
    border: 1px solid #755b41;
    margin-right: 20px;
    min-width: 200px;
    min-height: 50px;

    letter-spacing: 3.9px;
    background-color: white;
    font-family: JinXuanMedium;
    font-size: 18px;
    color: #755b41;

    :last-child {
      margin-right: 0px;
    }

    :focus {
      outline: none;
    }
  }

  @media screen and (max-width: 550px) {
    button {
      min-width: 150px;
      font-size: 14px;
    }
  }

  @media screen and (max-width: 375px) {
    button {
      min-width: 120px;
    }
  }
`;

export default connect(
  null,
  ActionCreator
)(FindIntroduction);
